import {loginUrl, languagesMenu} from '../../utils';
import {scrollDropdownWhenItemsAmountIsBiggerThen} from '../../data/constants.json';
import {links, linkContent, homeLink} from '../common';
import * as css from './desktop.scss';
import iconsGlobe from '../svg/globe';
import iconsArrowDown from '../svg/arrowDown';
import {defaultProfileImage} from '../../config';

const renderDropdownLinks = (items, tabIndex, isMenu) => {
  return links(
    items,
    {
      list: items => items.length > scrollDropdownWhenItemsAmountIsBiggerThen ? [css.dropdown, css.limitHeight] : css.dropdown,
      item: css.dropdownItem,
      itemContent: css.dropdownItemContent
    },
    null,
    tabIndex,
    {
      ...(isMenu && {role: 'menu'}),
    },
    {
      ...(isMenu && {role: 'menuitem'}),
    },
    null,
  );
};

const dropdown = (items, {title = '', iconClass = '', icon = null, tabIndex = null, tabIndexForButton = tabIndex, hideButton = false, buttonAriaLabel = null, buttonDataHook = null, isMenu = false}) => {
  return `
    <button
      class="${css.icon} ${iconClass} ${css.dropdownButton}"
      title="${title}"
      ${items && items.length > 0 ? `aria-haspopup="true"` : ''}
      ${tabIndexForButton !== null ? `tabindex="${tabIndexForButton}"` : ''}
      ${hideButton ? 'aria-hidden="true"' : ''}
      ${buttonAriaLabel ? `aria-label="${buttonAriaLabel}"` : ''}
      ${buttonDataHook ? `data-hook="${buttonDataHook}"` : ''}
    >
      ${icon || ''}
    </button>

    ${renderDropdownLinks(items, tabIndex, isMenu)}
  `;
};

const renderUserFlow = (config, {profileImage, userName}, userLinks, t) => {
  return `
    <nav class="${css.user} ${css.hasDropdown}" tabindex="${config.tabIndex[0]}" aria-label="${t('user_menu')}" data-hook="user-nav">
      <img
        src="${profileImage || defaultProfileImage(config)}"
        alt="${userName}"
        class="${css.userPic}"
        aria-hidden="true"
        id=${css.profileImage}
        data-hook="profile-image"
      >
      <div class="${css.userPicFallBack}" data-hook="fallback-image">&nbsp;</div>
      <div class="${css.userName}" aria-hidden="true" data-hook="user-name">${userName}</div>
      ${dropdown(userLinks, {title: '', iconClass: css.iconInlineArrowDown, icon: iconsArrowDown, tabIndex: config.tabIndex[0], tabIndexForButton: -1, buttonDataHook: 'arrow-down', isMenu: true})}
    </nav>
  `;
};

const renderLanguagePicker = (config, t, location) => {
  return `
    <div class="${css.languagePicker} ${css.hasDropdown}" data-hook="language-picker">
        ${dropdown(languagesMenu((config.languagePickerList || config.supportedLanguages).filter(language => config.language !== language), location, config), {title: t('choose_language'), iconClass: css.iconInlineGlobe, icon: iconsGlobe, tabIndex: config.tabIndex[0], buttonDataHook: 'globe-icon'})}
    </div>`;
};

const renderMainNavLinks = (mainLinks, config) => {
  if (config.accessibilityChanges) {
    return `
      <nav aria-label="site" class="${css.siteNavigation}">
        <ul class="${css.navigation}" data-hook="nav-links">
            ${mainLinks.map(item => `
              <li class="${css.navigationItem} ${item.subs && item.subs.length ? css.hasDropdown : ''}">
                ${linkContent(item, {itemContent: css.navigationItemContent}, config.tabIndex[0])}
                ${item.subs && item.subs.length ? dropdown(item.subs.map(sub => ({...sub, tab: item.tab, subTab: sub.tab})), {title: '', icon: iconsArrowDown, tabIndex: config.tabIndex[0], tabIndexForButton: -1, hideButton: true, buttonDataHook: 'arrow-down'}) : ''}
              </li>
        `).join('')}
        </ul>
    </nav>`;
  }
  return `
    <ul class="${css.navigation}" role="menu" data-hook="nav-links">
        ${mainLinks.map(item => `
          <li class="${css.navigationItem} ${item.subs && item.subs.length ? css.hasDropdown : ''}">
            ${linkContent(item, {itemContent: css.navigationItemContent}, config.tabIndex[0], {role: 'menuitem'})}
            ${item.subs && item.subs.length ? dropdown(item.subs.map(sub => ({...sub, tab: item.tab, subTab: sub.tab})), {title: '', icon: iconsArrowDown, tabIndex: config.tabIndex[0], tabIndexForButton: -1, hideButton: true, buttonDataHook: 'arrow-down'}) : ''}
          </li>
    `).join('')}
    </ul>`;
};

const renderAnonymousFlow = (config, t, isMobile, location) => {
  return `
  ${!config.hideLanguagePickerOnDesktop ? renderLanguagePicker(config, t, location) : ''}
    <a
      href="${loginUrl(config, isMobile)}"
      title="${t('title_signin')}"
      class="${css.signinButton}"
      tabindex="${config.tabIndex[0]}"
      role="button"
      data-hook="login"
      >${t('signin')}
    </a>
  `;
};

export default ({mainLinks, userLinks, user, t, config, location = null, isMobile}) => `
  <a
    href="${homeLink(config.language)}"
    class="${css.logo}"
    title="${t('title_wix_logo')}"
    tabindex="${config.tabIndex[0]}"
    data-hook="header-wix-logo"
  >
  </a>

  ${!config.hideMainLinksOnDesktop ? renderMainNavLinks(mainLinks, config) : ''}

  ${user ? renderUserFlow(config, user, userLinks, t) : renderAnonymousFlow(config, t, isMobile, location)}
`;
